/* B&M – Texte + vidéo (sections/bm-video-story.liquid).
   - La vidéo n'est téléchargée que lorsqu'elle approche de l'écran (src posée depuis data-src), puis lue
     sans le son en boucle ; elle se met en pause quand elle sort de l'écran.
   - « Réduire les animations » activé : la vidéo n'est jamais chargée, l'image reste affichée.
   - Erreur de chargement ou lecture refusée : la vidéo est masquée, l'image reste affichée. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function fail(video) {
    video.classList.remove('is-playing');
    video.classList.add('is-failed');
  }

  function play(video) {
    if (reduceMotion.matches || video.classList.contains('is-failed')) return;
    if (!video.getAttribute('src')) {
      video.addEventListener('error', function () { fail(video); }, { once: true });
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      video.muted = true;
      video.src = video.getAttribute('data-src');
    }
    var attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(function (error) {
        // Lecture automatique refusée (mode économie d'énergie…) : on garde l'image.
        if (error && error.name === 'NotAllowedError') fail(video);
      });
    }
  }

  function init(root) {
    var videos = (root || document).querySelectorAll('[data-bm-vstory-video]:not([data-bm-ready])');
    videos.forEach(function (video) {
      video.setAttribute('data-bm-ready', '');
      if (reduceMotion.matches) return;

      if (!('IntersectionObserver' in window)) {
        play(video);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play(video);
            } else if (video.getAttribute('src')) {
              video.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Éditeur de thème : la section peut être rechargée.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
